export const GET_COMPANIES_REQUEST = 'GET_COMPANIES_REQUEST';
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';
export const GET_COMPANIES_FAILURE = 'GET_COMPANIES_FAILURE';

export const getCompaniesRequest = (filters = {}) => ({
    type: GET_COMPANIES_REQUEST,
    payload: {
        filters
    }
});

export const getCompaniesSuccess = companies => ({
    type: GET_COMPANIES_SUCCESS,
    payload: {
        companies
    }
});

export const getCompaniesFailure = err => ({
    type: GET_COMPANIES_FAILURE,
    error: err
});
